/**
 * Costanti di configurazione API condivise tra httpClient, authSlice e
 * refreshAuth. File foglia: nessuna dipendenza interna, nessun ciclo.
 */
export const CRM_BASE_URL =
  (import.meta.env.VITE_CRM_BASE_URL as string | undefined) ?? '/o/crm/v1_0';
